import { ASSIGNABLE_SYSTEM_TAGS, TAG_TYPES } from '@/modules/file/constants'

/**
 * checks whether a system tag can be assigned based on its tagType
 *  @param {string} tagType
 *  @return boolean
 */
export const isAssignableSystemTag = (tagType) => {
  if (tagType === TAG_TYPES.CUSTOM || tagType === TAG_TYPES.DOCUMENTS) return true
  let result = false
  Object.values(ASSIGNABLE_SYSTEM_TAGS).forEach(({ type }) => {
    if (type === tagType) {
      result = true
    }
  })
  return result
}
